/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.panel--basic[_ngcontent-%COMP%]{z-index:5}.panel--justified[_ngcontent-%COMP%]{z-index:4}.panel--pills[_ngcontent-%COMP%]{z-index:3}.panel--stacked[_ngcontent-%COMP%]{z-index:2}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdWktZWxlbWVudC90YWItYW5kLW5hdi90YWItYW5kLW5hdi1kZW1vLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdWktZWxlbWVudC90YWItYW5kLW5hdi90YWItYW5kLW5hdi1kZW1vLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/ui-element/tab-and-nav/tab-and-nav-demo.component.scss.shim.ngstyle.ts